import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import {
  IComplaintDashboardFilterOptions,
  ComplaintsDashboardDimensionKey,
  ComplaintsDashboardFilterKey,
  IComplaintsDashboardFilters,
  IComplaintsDashboardTrendView,
  IComplaintsDashboardView,
} from '../../../core/interfaces/complaints-dashboard.interface';
import {
  clearDimensionFilters,
  createDefaultFilters,
  formatLocalDate,
  toggleFilter,
} from './complaints-dashboard.helper';

@Injectable()
export class ComplaintsDashboardStore {
  private filtersSubject = new BehaviorSubject<IComplaintsDashboardFilters>(
    createDefaultFilters(new Date()),
  );
  private filterOptionsSubject = new BehaviorSubject<
    IComplaintDashboardFilterOptions

  >(undefined);

  private viewSubject = new BehaviorSubject<IComplaintsDashboardView>(
    undefined,
  );
  private trendSubject = new BehaviorSubject<IComplaintsDashboardTrendView>(
    undefined,
  );
  private trendLoadingSubject = new BehaviorSubject<boolean>(false);
  private trendFailedSubject = new BehaviorSubject<boolean>(false);
  private loadFailedSubject = new BehaviorSubject<boolean>(false);

  filters$: Observable<
    IComplaintsDashboardFilters

  > = this.filtersSubject.asObservable();

  filterOptions$: Observable<
    IComplaintDashboardFilterOptions

  > = this.filterOptionsSubject.asObservable();

  view$: Observable<IComplaintsDashboardView> = this.viewSubject.asObservable();

  trend$: Observable<
    IComplaintsDashboardTrendView

  > = this.trendSubject.asObservable();

  trendLoading$: Observable<boolean> = this.trendLoadingSubject.asObservable();
  trendFailed$: Observable<boolean> = this.trendFailedSubject.asObservable();
  loadFailed$: Observable<boolean> = this.loadFailedSubject.asObservable();

  setFilter(key: ComplaintsDashboardFilterKey, value: string) {
    this.filtersSubject.next(
      Object.assign({}, this.filters, { [key]: value }),
    );
  }

  toggle(key: ComplaintsDashboardDimensionKey, value: string) {
    this.filtersSubject.next(toggleFilter(this.filters, key, value));
  }

  clearFilters() {
    this.filtersSubject.next(clearDimensionFilters(this.filters));
  }

  setFilterOptions(options: IComplaintDashboardFilterOptions) {
    this.filterOptionsSubject.next(options);
  }

  setView(view: IComplaintsDashboardView) {
    this.viewSubject.next(view);
  }

  setTrend(trend: IComplaintsDashboardTrendView) {
    this.trendSubject.next(trend);
  }

  setTrendLoading(loading: boolean) {
    this.trendLoadingSubject.next(loading);
  }

  setTrendFailed(failed: boolean) {
    this.trendFailedSubject.next(failed);
  }

  setLoadFailed(failed: boolean) {
    this.loadFailedSubject.next(failed);
  }

  get filters(): IComplaintsDashboardFilters {
    return this.filtersSubject.getValue();
  }

  get filterOptions(): IComplaintDashboardFilterOptions {
    return this.filterOptionsSubject.getValue();
  }

  get view(): IComplaintsDashboardView {
    return this.viewSubject.getValue();
  }

  get trend(): IComplaintsDashboardTrendView {
    return this.trendSubject.getValue();
  }

  get trendFailed(): boolean {
    return this.trendFailedSubject.getValue();
  }

  get loadFailed(): boolean {
    return this.loadFailedSubject.getValue();
  }

  get maxDate(): string {
    return formatLocalDate(new Date());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-dashboard/complaints-dashboard.store.ts